<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link v-if="!menus.includes('OverviewSuper')" :class="checkSelected('overview')" to="/dashboard/overview">
        <i>
        <b-icon icon="pie-chart-fill" aria-hidden="true"></b-icon></i>
        <p>Dashboard</p>
      </sidebar-link>
      <!-- <sidebar-link v-if="menus.includes('User')" to="/dashboard/user"> -->
      <sidebar-link  :class="checkSelected('user')" v-if="menus.includes('User')" to="/dashboard/user">
        <i>
        <b-icon icon="people" aria-hidden="true"></b-icon></i>
        <p>Users</p>
      </sidebar-link>
      <sidebar-link  :class="checkSelected('accounts')" v-if="menus.includes('Accounts')" to="/dashboard/accounts">
        <i>
        <b-icon icon="people" aria-hidden="true"></b-icon></i>
        <p>Accounts</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('building')" v-if="menus.includes('Building')" to="/dashboard/building">
        <i>
        <b-icon icon="building" aria-hidden="true"></b-icon></i>
        <p>Buildings</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('house')" v-if="menus.includes('House')" to="/dashboard/house">
        <i>
        <b-icon icon="house" aria-hidden="true"></b-icon></i>
        <p>House</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('meterconfig')" v-if="menus.includes('MeterConfig')" to="/dashboard/meter-config">
        <i>
        <b-icon icon="speedometer2" aria-hidden="true"></b-icon></i>
        <p>Meter Config</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('tenant')"  v-if="menus.includes('Tenant')" to="/dashboard/tenant">
        <i>
        <b-icon icon="people-fill" aria-hidden="true"></b-icon></i>
        <p>Tenants</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('owner')"  v-if="menus.includes('Owner')" to="/dashboard/owner">
        <i>
        <b-icon icon="person-badge" aria-hidden="true"></b-icon></i>
        <p>Owners</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('ownership')"  v-if="menus.includes('Ownership')" to="/dashboard/ownership">
        <i>
        <b-icon icon="key" aria-hidden="true"></b-icon></i>
        <p>Ownership</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('contracts')"  v-if="menus.includes('Contract')" to="/dashboard/contracts">
        <i>
        <b-icon icon="ui-checks" aria-hidden="true"></b-icon></i>
        <p>Contracts</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('payments')"  v-if="menus.includes('Payment')"  to="/dashboard/payments">
        <i>
        <b-icon icon="cash-coin" aria-hidden="true"></b-icon></i>
        <p>Payments</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('collection')"  v-if="menus.includes('Collection')"  to="/dashboard/collection">
        <i>
        <b-icon icon="cash-coin" aria-hidden="true"></b-icon></i>
        <p>Collection</p>
      </sidebar-link>
       <sidebar-link :class="checkSelected('report')"  v-if="menus.includes('Report')"  to="/dashboard/report">
        <i>
        <b-icon icon="bar-chart-steps" aria-hidden="true"></b-icon></i>
        <p>Report</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('House_Owner_Report')"  v-if="menus.includes('House_Owner_Report')"  to="/dashboard/house/owner/report">
        <i>
        <b-icon icon="bar-chart-steps" aria-hidden="true"></b-icon></i>
        <p>Report</p>
      </sidebar-link>
      <!-- Super Admin Links -->
      <sidebar-link :class="checkSelected('superoverview')" v-if="menus.includes('OverviewSuper')" to="/dashboard/super/overview">
        <i><b-icon icon="pie-chart-fill" aria-hidden="true"></b-icon></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('superuser')" v-if="menus.includes('UserSuper')"  to="/dashboard/super/user">
        <i><b-icon icon="people" aria-hidden="true"></b-icon></i>
        <p>Users</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('superbuilding')" v-if="menus.includes('BuildingSuper')"  to="/dashboard/super/building">
        <i><b-icon icon="building" aria-hidden="true"></b-icon></i>
        <p>Buildings</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('superhouse')" v-if="menus.includes('HouseSuper')"  to="/dashboard/super/house">
        <i><b-icon icon="house" aria-hidden="true"></b-icon></i>
        <p>House</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('supertenant')" v-if="menus.includes('TenantSuper')"  to="/dashboard/super/tenant">
        <i><b-icon icon="people-fill" aria-hidden="true"></b-icon></i>
        <p>Tenants</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('supercontract')" v-if="menus.includes('ContractSuper')"  to="/dashboard/super/contract">
        <i><b-icon icon="ui-checks" aria-hidden="true"></b-icon></i>
        <p>Contracts</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('superpayment')" v-if="menus.includes('PaymentSuper')"  to="/dashboard/super/payment">
        <i><b-icon icon="cash-coin" aria-hidden="true"></b-icon></i>
        <p>Payments</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('superauditlogs')" v-if="menus.includes('AuditLogs_Super')"  to="/dashboard/super/audit-logs">
        <i><b-icon icon="journal-text" aria-hidden="true"></b-icon></i>
        <p>Audit Logs</p>
      </sidebar-link>
      <!-- <sidebar-link to="/dashboard/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>User Profile</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Table list</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/icons">
        <i class="nc-icon nc-atom"></i>
        <p>Icons</p>
      </sidebar-link> -->
      <!-- <sidebar-link to="/dashboard/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Maps</p>
      </sidebar-link> -->
      <!-- <sidebar-link to="/dashboard/notifications">
        <i class="nc-icon nc-bell-55"></i>
        <p>Notifications</p>
      </sidebar-link> -->

      <!-- <template slot="bottom-links">
        <sidebar-link class="active"
                      to="/dashboard/upgrade">
          <i class="nc-icon nc-alien-33"></i>
          <p>Upgrade to PRO</p>
        </sidebar-link>
      </template> -->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
/* Fix footer positioning in dashboard layout */
.main-panel {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 0 !important;
}

.dashboard-content {
  flex: 1;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

.content-footer {
  margin-top: auto;
  position: relative;
  z-index: 10;
}
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data () {
      return {
        menus: [],
        isSuper: false
      }
    },
    mounted() {
      this.getMenus();
      this.isSuper = sessionStorage.getItem('mainRole') === 'SUPER';
    },
    computed: {
      currentRouterName(){
        return this.$route.name;
      }
    },
    methods: {
      checkSelected(path){
        if(this.$route.name.toLowerCase() === path)
          return "selected";
        else
          return "";
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      getMenus(){
        var some = sessionStorage.getItem('modules');
        if(some !== "" || some !== null){
          this.menus = some.split(",");
        }else{
          this.$router.push('/');
        }
      }
    }
  }

</script>
<style>
.selected > a{
    background: rgba(255, 255, 255, 0.13);
    opacity: 1;
}
</style>